<template>
    <div class="home">
        <el-container style="height: 100%;">
            <el-header style="height: 4%; display: flex;justify-content: space-between;">
                <div style="display: flex;gap:10px;width: 320px;">
                    <img src="../assets/favicon.png" alt="">
                    <div class="header-text-left">凌丰供应商系统</div>
                    <div class="pe-header-text">发货单</div>
                </div>

                <div style="width: 320px;">
                    <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                    <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
                </div>

            </el-header>
            <el-main style="height: 94%;padding: 0;box-sizing: border-box;display: flex;flex-direction: column;">
                <div class="toolbar">
                    <el-button icon="el-icon-refresh" plain size="small" @click="senior_search">刷新</el-button>
                    <el-popover :width="300" trigger="click">
                        <template #reference>
                            <el-button icon="el-icon-menu" plain size="small">状态筛选</el-button>
                        </template>
                        <template #default>
                            <div>
                                <el-radio-group v-model="radio1" size="mini" @change="radio_change">
                                    <el-radio-button label="全部"></el-radio-button>
                                    <el-radio-button label="在途"></el-radio-button>
                                    <el-radio-button label="部分签收"></el-radio-button>
                                    <el-radio-button label="签收完成"></el-radio-button>
                                </el-radio-group>
                            </div>
                        </template>
                    </el-popover>
                    <el-popover :width="540" trigger="click">
                        <template #reference>
                            <el-button icon="el-icon-search" plain size="small">高级搜索</el-button>
                        </template>
                        <template #default>
                            <div>
                                <el-form label-width="100px">
                                    <el-form-item label="送货单编号">
                                        <el-input style="width: 300px;font-size: 14px;" v-model="searchobj.formId"
                                            clearable placeholder="请输入送货单编号" size="mini"></el-input>
                                    </el-form-item>
                                    <el-form-item label="制单日期范围">
                                        <el-date-picker v-model="createdate" type="datetimerange" align="right"
                                            style="font-size: 14px;" @change="createdate_change"
                                            start-placeholder="开始日期" end-placeholder="结束日期"
                                            :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss"
                                            size="mini">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="合同号">
                                        <el-select style="width: 300px;font-size: 14px;" size="mini" clearable
                                            default-first-option v-model="searchobj.projectId" filterable
                                            placeholder="选择合同号" remote :remote-method="async_projectId"
                                            :loading="loading2">
                                            <el-option v-for="item in project_options" :key="item.id"
                                                :label="item.trackNumber" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="物料">
                                        <el-select style="width: 400px;font-size: 14px;" size="mini" clearable
                                            filterable remote value-key="materialId" v-model="searchobj.materialId"
                                            placeholder="请输入物料名称、型号、编码" :remote-method="async_material"
                                            :loading="loading2" default-first-option>
                                            <el-option v-for="item in material_options" :key="item.materialId"
                                                style="width: 450px;" :label="(roleName != '供应商' || roleName == '供应商' && item.nameAlias.length == 0) ?
                                                    (item.materialName + '--' + item.materialType) :
                                                    (item.nameAlias.join('--'))" :value="item.materialId">
                                                <template>
                                                    <div style="display: flex;gap:10px">
                                                        <div
                                                            style="width: 50%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                            {{ item.materialName }}</div>
                                                        <div
                                                            style="width: 50%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;">
                                                            {{ item.materialType }}</div>
                                                    </div>
                                                </template>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="供应商" v-if="roleName != '供应商'">
                                        <el-select style="width: 300px;font-size: 14px;" size="mini" clearable
                                            filterable remote v-model="searchobj.supplierId" placeholder="选择供应商"
                                            :remote-method="async_supplier" :loading="loading2" default-first-option>
                                            <el-option v-for="item in supplier_options" :key="item.id"
                                                style="width:100%" :label="item.supplierName" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <div></div>
                                    </el-form-item>
                                </el-form>
                                <div style="text-align: right;">
                                    <el-button type="success" @click="goto_search" size="mini">搜索</el-button>
                                </div>
                            </div>
                        </template>
                    </el-popover>
                    <el-button icon="el-icon-download" plain size="small"
                        @click="exportAll_show = true">批量导出</el-button>
                </div>
                <div class="table-body">
                    <el-table ref="multipleTable" :data="table_data" border height="100%"
                        :header-row-style="{ height: '0' }"
                        :header-cell-style="{ background: '#fff', color: '#000', padding: '0' }"
                        :row-style="{ height: '0' }" :cell-style="{ padding: '2px 0' }" row-key="formId"
                        v-loading="table_loading">
                        <!-- <el-table-column type="selection" width="40"></el-table-column> -->
                        <el-table-column label="序号" width="50" align="center">
                            <template slot-scope="{ $index }">
                                <span>{{ $index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="单号" prop="formId" width="200" align="center" sortable></el-table-column>
                        <el-table-column label="制单日期" prop="createDate" width="190" align="center"
                            sortable></el-table-column>
                        <el-table-column label="状态" prop="status" width="95" align="center" sortable>
                            <template slot-scope="scope">
                                <el-tag :type="status_color(scope.row)" size="mini" style="font-size: 14px;">{{
                                    status_list[scope.row.status] }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="完成日期" prop="finishDate" width="190" align="center"
                            sortable></el-table-column>
                        <el-table-column label="供应商" prop="supplierName" width="250" align="center"
                            v-if="roleName != '供应商'" sortable></el-table-column>
                        <el-table-column label="金额" prop="totalPrice" width="130" align="center"
                            sortable></el-table-column>
                        <el-table-column align="center" width="280" label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" type="success" plain
                                    @click="searchbyid(scope.row)">查看</el-button>
                                <el-button size="mini" type="primary" plain
                                    @click="handelPrint(scope.row)">打印</el-button>
                                <el-button size="mini" type="primary" plain
                                    @click="handelExport(scope.row)">导出</el-button>
                                <el-button size="mini" type="danger" plain
                                    @click="del_sentform(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="table-footer">
                    <el-pagination background layout="sizes, prev, pager, next" :total="totalPage"
                        @size-change="handleSizeChange" @current-change="change_data"
                        :current-page="searchobj.currentPage" :page-size="searchobj.pageSize">
                    </el-pagination>
                </div>
            </el-main>
            <el-footer style="height: 2%; font-size: 13px;color: #fff;">© 2024 LINKFAIRTECH 版权所有</el-footer>
        </el-container>

        <el-dialog title="批量导出汇总单" :visible.sync="exportAll_show" width="30%">
            <el-form ref="exportAll" :model="exportAll_data" :rules="rules">
                <el-form-item label="签收时间范围" label-width="100px" prop="dateRange">
                    <el-date-picker v-model="dateRange" type="datetimerange" align="right"
                        style="font-size: 14px;width: 100%;" start-placeholder="开始日期" end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" size="mini">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="供应商" label-width="100px" v-if="roleName != '供应商'" prop="supplierId">
                    <el-select style="width: 100%;font-size: 14px;" size="mini" clearable filterable remote
                        v-model="exportAll_data.supplierId" placeholder="选择供应商" :remote-method="async_supplier"
                        :loading="loading2" default-first-option>
                        <el-option v-for="item in supplier_options" :key="item.id" style="width:100%"
                            :label="item.supplierName" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="exportAll_show = false">取消</el-button>
                <el-button type="success" plain size="small" @click="exportAll_submit">批量导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import * as sentFormApi from '@/Api/sentFormApi.js'
import { get_project, get_material, get_supplier } from '@/utils/func.js'
export default {
    name: 'sendPage',
    components: {
    },
    data() {
        return {
            homeDate: '',
            userNme: sessionStorage.getItem('userName'),
            radio1: '全部',
            searchobj: {
                pageSize: 30,
                currentPage: 1,
            },
            gettable_params: {
                pageSize: 30,
                currentPage: 1
            },
            header: {
                headers: { token: sessionStorage.getItem('token') }
            },
            table_data: [],
            table_data_detail: [],
            table_loading: false,
            multipleSelection: [],
            totalPage: 0,
            useDate: '',
            createdate: '',
            project_options: [],
            material_options: [],
            supplier_options: [],
            loading2: false,
            roleName: sessionStorage.getItem('roleName'),
            status_list: ['未发货', '部分发货', '在途', '部分签收', '签收完成'],
            exportAll_show: false,
            exportAll_data: {
                startFinishTime: '',
                endFinishTime: '',
                itemStatus: 4,
                pageSize: 5000,
                currentPage: 1
            },
            rules: {
                supplierId: [
                    { required: true, message: '请选择供应商', trigger: ['blur', 'change'] }
                ],
            }
        }
    },
    computed: {
        dateRange: {
            get() {
                return [this.exportAll_data.startFinishTime, this.exportAll_data.endFinishTime];
            },
            set(value) {
                if (value == null) {
                    this.exportAll_data.startFinishTime = '';
                    this.exportAll_data.endFinishTime = '';
                } else {
                    this.exportAll_data.startFinishTime = value[0];
                    this.exportAll_data.endFinishTime = value[1];
                }
            }
        },
    },
    methods: {
        //显示时间
        showTime() {
            setTimeout(() => {
                this.showTime();
            }, 1000);
            this.homeDate = this.$getTime()
        },
        //退出
        logback() {
            this.$confirm('退出登录', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                console.log("**********退出**********");
                sessionStorage.clear();
                this.$router.push("/login");
            }).catch(() => { })
        },
        //页码发生变化时
        change_data(e) {
            this.searchobj.currentPage = e
            this.senior_search()
        },
        //修改每页大小
        handleSizeChange(e) {
            this.searchobj.pageSize = e
            this.searchobj.currentPage = 1
            this.senior_search()
        },
        //状态颜色
        status_color(row) {
            if (row.status == 0) return 'info'
            else if (row.status == 1 || row.status == 3) return 'warning'
            else if (row.status == 2) return ''
            else if (row.status == 4) return 'success'
        },

        del_sentform(row) {
            if (row.status != 2) {
                //有签收的内容，不能删除整张单
                this.$alert('该送货单已有内容签收，不能整单删除，如需删除表单部分项，请查看表单详情进行删除', '警告')
                return
            }
            this.$confirm('此操作将会删除整张送货单', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let del_list = []
                let search_idlist = new Object()
                search_idlist.pageSize = 1000
                search_idlist.currentPage = 1
                search_idlist.formId = row.formId
                sentFormApi.sentFormQuery(search_idlist, this).then(res => {
                    del_list = res.records.map(item => item.id)
                    this.del_sendform_item(del_list)
                }).catch(() => { })

            }).catch(() => {
            });
        },
        del_sendform_item(del_list) {
            sentFormApi.delSentForm(del_list, this).then(() => {
                this.$message({ type: 'success', message: '删除成功' })
                this.senior_search()
            }).catch(() => { })
        },

        usedate_change() {
            this.searchobj.startUseDate = this.useDate[0]
            this.searchobj.endUseDate = this.useDate[1]
        },
        createdate_change() {
            if (this.createdate) {
                this.searchobj.startCreateTime = this.createdate[0]
                this.searchobj.endCreateTime = this.createdate[1]
            } else {
                this.searchobj.startCreateTime = ''
                this.searchobj.endCreateTime = ''
            }

        },
        async_projectId(query) {
            get_project(this, query)
        },
        async async_material(query) {
            get_material(this, query)
        },
        async_supplier(query) {
            get_supplier(this, query)
        },
        goto_search() {
            this.searchobj.currentPage = 1
            this.senior_search()
        },
        senior_search() {
            this.table_loading = true
            sentFormApi.searchAllSentForm(this.searchobj, this).then(res => {
                this.table_data = res.records
                this.totalPage = res.total
            }).catch(() => { }).finally(() => {
                this.table_loading = false
            })
        },
        searchbyid(row) {
            //页面跳转
            const { href } = this.$router.resolve({
                path: '/sendPage_detail',
                query: {
                    check_list: row.formId,
                    check_status: 1,
                }
            })
            window.open(href, '_blank')
        },
        handelPrint(row) {
            // console.log(row);
            //页面跳转
            const { href } = this.$router.resolve({
                path: '/printout',
                query: {
                    check_list: row.formId,
                    check_status: 2,
                }
            })
            window.open(href, '_blank')
        },
        radio_change() {
            // console.log(this.radio1);
            if (this.radio1 == '在途') {
                this.searchobj.formStatus = 2
            } else if (this.radio1 == '部分签收') {
                this.searchobj.formStatus = 3
            } else if (this.radio1 == '签收完成') {
                this.searchobj.formStatus = 4
            } else if (this.radio1 == '全部') {
                this.searchobj.formStatus = ''
            }
            this.searchobj.currentPage = 1
            this.senior_search()
        },
        async handelExport(row) {
            let formData = []
            try {
                let res = await sentFormApi.sentFormQuery({ pageSize: 1000, currentPage: 1, formId: row.formId }, this, true)
                if (res) formData = res.records
            } catch (error) {
                return
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(row.formId);
            worksheet.addRow(['送货单']);
            worksheet.addRow(['编号：', row.formId, '', '', '总金额：', row.totalPrice, '', '状态：', this.status_list[row.status]]);
            worksheet.addRow(['创建时间：', row.createDate, '', '', '', '完成时间：', row.finishDate,]);
            worksheet.addRow(['采购方：', this.$store.state.companyId == 'LFWZ' ? '广东凌丰五金装备科技股份有限公司' : this.$store.state.companyId == 'NTLD' ? '南通立德装备科技有限公司' : '', '', '', '', '供应方：', row.supplierName]);
            worksheet.addRow(['序号', '合同号', '需用日期', '状态', '完成时间', '物料名称', '规格型号', '物料编码', '单位', '备注', '单价', '金额', '发货数量', '签收数量']);
            formData.forEach((item, index) => {
                const rowIndex = index + 6; // 跳过表头行
                const row = worksheet.getRow(rowIndex);
                row.values = [index + 1, item.trackNumber, item.useDate, this.status_list[item.status], item.itemFinishTime ? item.itemFinishTime : '', item.materialName, item.materialType, item.materialBarcode, item.unit, item.itemRemark ? item.itemRemark : '', item.price, item.totalPrice, item.outputNumber, item.receiveNumber];
            })
            // 自动调整列宽度以适应内容
            worksheet.columns.forEach(column => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, cell => {
                    const columnLength = cell.value ? cell.value.toString().length : 10;
                    if (columnLength > maxLength) {
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < 10 ? 10 : maxLength + 2;
            });
            worksheet.mergeCells('A1:N1');
            worksheet.mergeCells('B2:C2');
            worksheet.mergeCells('B3:E3');
            worksheet.mergeCells('G3:I3');
            worksheet.mergeCells('B4:E4');
            worksheet.mergeCells('G4:I4');
            worksheet.getCell('A1').font = { size: 20 };
            worksheet.eachRow({ startingRow: 2 }, function (row, rowNumber) {
                row.height = 20; // 设置除第一行以外的所有行的行高为20
            });
            worksheet.getRow(1).height = 30;
            // 设置水平垂直居中
            worksheet.eachRow(function (row, rowNumber) {
                row.eachCell(function (cell) {
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }; // 设置单元格内容水平和垂直居中
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    }; // 设置单元格边框
                });
            });
            // 生成Excel文件
            const buffer = await workbook.xlsx.writeBuffer();

            // 创建Blob对象并保存文件
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileName = '送货单' + row.formId + '.xlsx';

            // 使用FileSaver保存文件
            saveAs(blob, fileName);
        },
        exportAll_submit() {
            this.$refs.exportAll.validate(valid => {
                if (valid) {
                    this.$confirm(`时间范围：</br>${this.exportAll_data.startFinishTime}--${this.exportAll_data.endFinishTime}`, '确认批量导出excel？', {
                        confirmButtonText: '确认',
                        cancelButtonText: '取消',
                        type: 'warning',
                        dangerouslyUseHTMLString: true
                    }).then(() => {
                        sentFormApi.sentFormQuery(this.exportAll_data, this, true).then(res => {
                            if (res.records.length > 0) {
                                this.exportAll_excel(res.records)
                                this.exportAll_show = false
                            } else {
                                this.$notify.warning({
                                    title: '该日期范围无数据',
                                    position: 'bottom-right',
                                });
                            }
                        }).catch(() => { })
                    }).catch(() => { })
                }
            })


        },
        async exportAll_excel(formData) {
            let sum = 0
            for (let item of formData) {
                sum += item.totalPrice
            }
            formData.sort((a, b) => parseInt(a.formId) - parseInt(b.formId));
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet(`${this.exportAll_data.startFinishTime.split(' ')[0]}--${this.exportAll_data.endFinishTime.split(' ')[0]}`);
            worksheet.addRow(['送货汇总单']);
            worksheet.addRow(['采购方：', this.$store.state.companyId == 'LFWZ' ? '广东凌丰五金装备科技股份有限公司' : this.$store.state.companyId == 'NTLD' ? '南通立德装备科技有限公司' : '', '', '', '供应方：', formData[0].supplier, '', '', '总金额：', sum.toFixed(3)]);
            worksheet.addRow(['送货单号', '状态', '签收日期', '物料名称', '规格型号', '单位', '发货数量', '签收数量', '单价', '金额', '备注']);
            formData.forEach((item, index) => {
                const rowIndex = index + 4; // 跳过表头行
                const row = worksheet.getRow(rowIndex);
                row.values = [item.formId, this.status_list[item.status], item.itemFinishTime.split(' ')[0], item.materialName,
                item.materialType, item.unit, item.outputNumber, item.receiveNumber,
                item.price, item.totalPrice, item.itemRemark ? item.itemRemark : ''];
            })
            // 自动调整列宽度以适应内容
            worksheet.columns.forEach(column => {
                let maxLength = 0;
                column.eachCell({ includeEmpty: true }, cell => {
                    const columnLength = cell.value ? cell.value.toString().length : 10;
                    if (columnLength > maxLength) {
                        maxLength = columnLength;
                    }
                });
                column.width = maxLength < 10 ? 10 : maxLength + 2;
            });
            worksheet.mergeCells('A1:K1');
            // worksheet.mergeCells('B2:C2');
            worksheet.mergeCells('B2:D2');
            worksheet.mergeCells('F2:H2');
            worksheet.mergeCells('J2:K2');
            worksheet.getCell('A1').font = { size: 20 };
            worksheet.eachRow({ startingRow: 2 }, function (row, rowNumber) {
                row.height = 20; // 设置除第一行以外的所有行的行高为20
            });
            worksheet.getRow(1).height = 30;
            worksheet.getRow(2).height = 25;
            worksheet.getRow(2).font = { size: 16 };
            // 设置水平垂直居中
            worksheet.eachRow(function (row, rowNumber) {
                row.eachCell(function (cell) {
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }; // 设置单元格内容水平和垂直居中
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    }; // 设置单元格边框
                });
            });
            // 生成Excel文件
            const buffer = await workbook.xlsx.writeBuffer();

            // 创建Blob对象并保存文件
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const fileName = `送货单${this.exportAll_data.startFinishTime.split(' ')[0]}--${this.exportAll_data.endFinishTime.split(' ')[0]}.xlsx`;

            // 使用FileSaver保存文件
            saveAs(blob, fileName);
        },
    },
    mounted() {
        this.showTime()
    },
    created() {
        this.senior_search()
    }
}
</script>
<style>
.home {
    height: 100%;
}

.el-header {
    background-color: #12b4bd;
}

.el-main {
    background-color: #ccc;
}

.el-footer {
    background-color: #12b4bd;
}

.el-table__body tr:hover>td {
    background-color: #c0ddaf !important;
}

.table-body .selected-row {
    background-color: #c0ddaf;
}

.nav .el-button {
    border-color: #12b4bd;
    color: #12b4bd;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
    /* 使用transform缩放选择框 */
}
</style>
<style scoped>
.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.el-form-item {
    margin-bottom: 12px;
}

.table-body {
    /* height: calc(100% - 52px); */
    flex: 1;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}

.toolbar {
    background-color: #fff;
    padding: 10px 15px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.toolbar .el-button {
    transition: all 0.2s ease;
}

.toolbar .el-button:hover {
    transform: translateY(-2px);
}
</style>